import { WEEKDAYS } from '../common/Const';
import { displayDate } from '../common/datePresentation';

function auditRecordDescription(event, teacherOptions = [], currentClass = null) {
  if (!event || !event.entity) return { label: '', current: false };
  if (event.entity.type === 'lessonregister') {
    const descriptor = event.entity.descriptor || {};
    const teacher = teacherOptions.find(option => option[0] === descriptor.teacherId);
    const date = descriptor.date && displayDate(descriptor.date);
    const label = [date, descriptor.startTime, teacher && teacher[1]].filter(Boolean).join(' · ');
    return { label: label || event.entity.label || event.entity.id, current: false };
  }
  if (event.entity.type !== 'classes') return { label: event.entity.label || event.entity.id, current: false };
  const descriptor = event.entity.descriptor || currentClass;
  if (!descriptor) return { label: `Grupa ${String(event.entity.id).slice(0, 8)}`, current: false };
  const weekday = WEEKDAYS.find(day => day.id === descriptor.dayOfWeek);
  const teacher = teacherOptions.find(option => option[0] === descriptor.teacherId);
  const dates = [descriptor.fromDate, descriptor.tillDate].filter(Boolean).map(date => displayDate(date));
  const range = dates.length === 2 && dates[0] !== dates[1] ? dates.join(' – ') : dates[0];
  return {
    label: [weekday && weekday.name, teacher && teacher[1], range].filter(Boolean).join(' · ') || `Grupa ${String(event.entity.id).slice(0, 8)}`,
    current: !event.entity.descriptor,
  };
}

export default auditRecordDescription;
